import { buildQueryString } from "./url";
import "whatwg-fetch";
import { SSO_AUTH_ERROR, FORBIDDEN_TENANT_ERROR } from "../src/utils/auth/authErrorTypes";
import { getTenantFromURL } from "../src/components/common/MultiTenancy/MultiTenancyHelper";
import keycloakManager from "../src/components/login/sso/keycloakManager";
import { getSessionCookies, setSessionCookies } from "../src/components/common/sessions/tokenHelper";
import store from "../src/store";
import { logout } from "../src/components/login/loginActions";
import userHasAccess from "../src/utils/userHasAccess";
import { EXTERNAL_ROLES } from "../src/utils/Roles";

export const ALL_SIMPLE_FETCH_ERRORS = [
    "terminated_client_error",
    "archived_member_error",
    "archived_client_error",
    "archived_division_error",
    "archived_class_error",
    "archived_dependent_person_error",
    "no_associated_client"
];

export default async (method, path, { query, body, options = {}, headers }) => {
    let [accessToken, refreshToken] = getSessionCookies();
    const tenantHeader = getTenantFromURL();

    if (accessToken && refreshToken) {
        try {
            [accessToken, refreshToken] = await keycloakManager.refreshTokens(accessToken, refreshToken);
            setSessionCookies(accessToken, refreshToken);
        } catch (e) {
            console.debug("Unabled to fetch new tokens");
        }
    }

    return new Promise((resolve, failure) => {
        let status;

        let apiUrl = path.includes("/v2/") || path.includes("/graphql") ? __APIV2_URL__ : __API_URL__;

        const url = options.localUrl ? path : apiUrl + path + buildQueryString(query, path);
        let requestHeaders = {};

        requestHeaders["tenant"] = tenantHeader;
        if (accessToken) {
            requestHeaders.Authorization = `JWT ${accessToken}`;
        }
        const languageCode = localStorage.getItem("languageCode");
        if (languageCode) {
            requestHeaders["Accept-Language"] = languageCode;
        }
        requestHeaders["Cache-Control"] = "no-cache";
        requestHeaders["Pragma"] = "no-cache";
        switch (options.contentType) {
            case "formData": {
                requestHeaders = { ...requestHeaders, ...headers };
                break;
            }
            default: {
                if (body) {
                    body = JSON.stringify(body);
                }
                requestHeaders = {
                    ...requestHeaders,
                    "content-type": "application/json",
                    accept: "application/json",
                    ...headers,
                };
                break;
            }
        }

        const opt = {
            method,
            body,
            headers: requestHeaders,
            ...options,
        };
        fetch(url, opt)
            .then((response) => {
                status = response.status;
                return response.text();
            })
            .then((data) => {
                if (data) {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        /* at least we tried :-( */
                    }
                }

                if (status >= 400) {
                    failure({ status, data });
                    redirectIfNeeded(data, status);
                    checkForToastErrors(data);
                } else {
                    resolve(data);
                }
            })
            .catch((e) => {
                redirectIfNeeded(e);
                failure(e);
            });
    });
};

function redirectIfNeeded(data, status) {
    const detail = data.detail;
    const isUserValidForAssociatedClientError = sessionStorage.getItem("associatedClients") && userHasAccess(EXTERNAL_ROLES, true);

    if (! !!detail) {
        if (400 < status && status < 500) { // Access issue
            if(isUserValidForAssociatedClientError) sessionStorage.setItem("hasAssociatedClientError", true);
            redirectTo("/dashboard");
        }

        return;
    }

    switch (detail.error_code) {
        case SSO_AUTH_ERROR:
            logout(`${window.location.origin}/login?timeout=true`);
            break;
        case FORBIDDEN_TENANT_ERROR: {
            const redirectTenant = detail.redirect_tenant.trim();
            redirectForForbiddenTenant(redirectTenant);
            break;
        }
        default:
            break;
    }
    if (data.detail === "associated_client" || (data.error == "Unauthorized" && data.message.errorCode === "associated_client")) 
        /** Set sessionStorage to later show error toast. */
        if(isUserValidForAssociatedClientError) sessionStorage.setItem("hasAssociatedClientError", true);

    if (status == 401){
        if(isUserValidForAssociatedClientError) sessionStorage.setItem("hasAssociatedClientError", true);
        redirectTo("/dashboard");
    } 
}

function checkForToastErrors(data) {
    if (data && data.error === "Bad Request") {
        if (data.message.errorCode === "terminated_client_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "terminatedClientModification",
            });
        } else if (data.message.errorCode === "archived_member_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "membersArchivedModifcation",
            });
        } else if (data.message.errorCode === "archived_client_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "clientArchivedModification",
            });
        } else if (data.message.errorCode === "archived_division_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "divisionArchivedModification",
            });
        } else if (data.message.errorCode === "archived_class_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "classArchivedModification",
            });
        } else if (data.message.errorCode === "archived_dependent_person_error") {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "dependentPersonArchivedModification",
            });
        }
        else if (data.message.errorCode === 'no_previous_coverage') {
            store.dispatch({
                type: "SHOW_TOAST",
                value: "noPreviousCoverageForRole",
            });
        }
    }
}

function redirectForForbiddenTenant(tenant) {
    let url = new URL(window.location.href);
    url.hostname = tenant + "." + url.hostname.split(".").slice(1).join(".");
    url.pathname = "/dashboard";
    url.search = "";
    window.location.href = url;
}
function redirectTo(path) {
    window.history.pushState(null, document.title, path);
    window.history.go();
}



// WEBPACK FOOTER //
// ./utils/simpleFetch.js